export enum ECrawlerServiceStatus {
  IDLE = 'idle',
  RUNNING = 'running',
  UNKNOWN = 'unknown'
}
